/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch, useHistory, useLocation} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {ResetPassword} from './components/ResetPassword'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Login2Fa} from './components/Login2Fa'
import {LoginPage} from './components/LoginPage'
import {AuthContextProvider} from './context/AuthContext'
import Setup2Fa from './components/Setup2Fa'
import Option2Fa from './components/Option2Fa'
import { PasswordExpired } from './components/PasswordExpired'
import SocialLinks from '../../../app/shared/components/SocialLinks'

export function AuthPage() {
  const history = useHistory()
  const location = useLocation<any>()

  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div className='container-fluid h-100 p-0'>
      <div className='row h-100 m-0'>
        <div className='col-md-4 d-flex flex-column align-items-center justify-content-center'>
          <div className='w-lg-500px p-10 p-lg-15 mx-auto' style={{maxWidth: '100%'}}>
            <div className='text-center mb-5'>
              <a href='#'>
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logos/doora-logo.png')}
                  className='h-40px'
                />
              </a>
            </div>
            <AuthContextProvider>
              <Switch>
                <Route path='/auth/login' exact component={LoginPage} />
                <Route
                  path='/auth/login-2fa'
                  render={() => (
                    <Login2Fa
                      cancelHandler={() => {
                        history.push('/auth/login', location.state)
                      }}
                    />
                  )}
                />
                <Route path='/auth/setup-2fa' exact component={Setup2Fa} />
                <Route path='/auth/option-2fa' exact component={Option2Fa} />
                <Route path='/auth/password-expired' exact component={PasswordExpired} />
                <Route path='/auth/reset-password' exact component={ResetPassword} />
                <Route path='/auth/registration' exact component={Registration} />
                <Route path='/auth/forgot-password' exact component={ForgotPassword} />
                <Redirect from='/auth' exact to='/auth/login' />
                <Redirect to='/auth/login' />
              </Switch>
            </AuthContextProvider>
            <SocialLinks />
          </div>
        </div>

        <div
          className='col-md-8 d-none d-md-flex justify-content-center align-items-center bgi-position-y-center position-x-center bgi-size-contain bgi-attachment-fixed'
          style={{
            position: 'relative',
            backgroundImage: `url('${toAbsoluteUrl('/media/logos/homes.jpg')}')`,
            backgroundSize: 'cover',
            //backgroundPosition: 'center center',
            //backgroundSize: 'auto auto',
            backgroundPosition: '0% 30%', // or 'center center'
            backgroundRepeat: 'no-repeat',
          }}
        >
          {/* Dark blur overlay */}
          <div
            style={{
              display: 'none',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.5)', // semi-transparent black
              backdropFilter: 'blur(6px)', // blur effect
              WebkitBackdropFilter: 'blur(6px)', // Safari support
              zIndex: 0, // behind text
            }}
          />

          <div className='text-center' style={{position: 'relative', zIndex: 1}}>
            <h1 className='text-white mb-10' style={{fontSize: '4.875rem'}}></h1>
            <h3 className='text-white mb-10'></h3>
          </div>
        </div>
      </div>
    </div>
  )
}
